import { render, staticRenderFns } from "./rede.vue?vue&type=template&id=2c0acc66"
import script from "./rede.vue?vue&type=script&lang=js"
export * from "./rede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports